import { mapState } from 'vuex'

export default {
  data: function () {
    return {
      pageTitle: null
    }
  },
  computed: {
    ...mapState({
      site: (state) => state.SiteStore.site
    })
  },
  head: {
    title: function () {
      return {
        inner: this.pageTitle,
        separator: '|',
        complement: this.site.name ? this.site.name + '管理画面' : 'b-master'
      }
    },
    link: function () {
      return [
        {
          rel: 'icon',
          type: 'image/x-icon',
          href: this.site.favicon ? this.site.favicon.url : ''
        }
      ]
    }
  }
}
